// extracted by mini-css-extract-plugin
export default {"container":"pdf-viewer_container__Rwm+X"};